import AuthContext from "../store/auth-context";
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout/Layout";
import HeroSection from "../components/HeroSection/HeroSection";
import './NotFound.scss';

const NotFoundPage = () => {
    let navigate = useNavigate();
    const authCtx = useContext(AuthContext);
    const isLoggedIn = authCtx.isLoggedIn;

    const goBack = () => {
        navigate(-1);
    };

    const goHome = () => {
        navigate(isLoggedIn ? '/' : '/login');
    };

    return (
        <Layout>
            <HeroSection/>
            <div className="not-found-wrapper">
                <div className="not-found-container">
                    <div className="not-found-content">
                        <div className="not-found-icon">
                            <svg viewBox="0 0 24 24" height="150" width="150" fill="none">
                                <g id="SVGRepo_bgCarrier" strokeWidth="0"/>
                                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>
                                <g id="SVGRepo_iconCarrier"> 
                                    <path d="M2 8L8 10" stroke="#4A0CB6" strokeWidth="1.5" strokeLinecap="round"/> 
                                    <path d="M6 4L8 7" stroke="#4A0CB6" strokeWidth="1.5" strokeLinecap="round"/> 
                                    <path opacity="0.5" d="M11 6.56252L14.7001 2.93755C16.1597 1.50753 18.7629 1.73938 20.5145 3.4554C22.266 5.17142 22.5027 7.72176 21.043 9.15178L18.1358 12" stroke="#4A0CB6" strokeWidth="1.5" strokeLinecap="round"/> 
                                    <path opacity="0.5" d="M15 15.5866L10.9653 20.001C9.57254 21.5247 7.0887 21.2777 5.41744 19.4492C3.74618 17.6207 3.52038 14.9032 4.91309 13.3795L6.17395 12" stroke="#4A0CB6" strokeWidth="1.5" strokeLinecap="round"/> 
                                </g>
                            </svg>
                            <h1 className="not-found-title">404</h1>
                            <p className="not-found-text">Oops! The page you're looking for doesn't exist.</p>
                        </div>
                        <div className="not-found-actions">
                            <button onClick={goBack} className="not-found-button back-button">Go Back</button>
                            <button onClick={goHome} className="not-found-button home-button">Go Home</button>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default NotFoundPage; 